import axiosInstance from "../utils/axios";

export interface LocationDTO {
  id: number;
  city: string;
  country: string;
  displayName: string;
  isActive: boolean;
}

export interface CreateLocationDTO {
  city: string;
  country: string;
  displayName?: string;
}

export interface UpdateLocationDTO {
  city?: string;
  country?: string;
  displayName?: string;
  isActive?: boolean;
}

export const locationService = {
  // Get all locations (including inactive)
  getAllLocations: async (): Promise<LocationDTO[]> => {
    const response = await axiosInstance.get("/locations");
    return response.data;
  },

  // Get only active locations (for dropdowns)
  getActiveLocations: async (): Promise<LocationDTO[]> => {
    const response = await axiosInstance.get("/locations/active");
    return response.data;
  },

  // Get location by ID
  getLocationById: async (id: number): Promise<LocationDTO> => {
    const response = await axiosInstance.get(`/locations/${id}`);
    return response.data;
  },

  // Get locations by country
  getLocationsByCountry: async (country: string): Promise<LocationDTO[]> => {
    const response = await axiosInstance.get(`/locations/country/${country}`);
    return response.data;
  },

  // Create a new location
  createLocation: async (location: CreateLocationDTO): Promise<LocationDTO> => {
    const response = await axiosInstance.post("/locations", location);
    return response.data;
  },

  // Update a location
  updateLocation: async (
    id: number,
    location: UpdateLocationDTO
  ): Promise<LocationDTO> => {
    const response = await axiosInstance.put(`/locations/${id}`, location);
    return response.data;
  },

  // Delete (soft delete) a location
  deleteLocation: async (id: number): Promise<void> => {
    await axiosInstance.delete(`/locations/${id}`);
  },
};

export default locationService;
